
import React from 'react'
import twitter from './svgs/twitter.svg'
import { BaseIcon } from './_base'

export const TwitterIcon = ({ size, fontSize, sx }) => {
    return (
        <BaseIcon icon={twitter} {...{ fontSize, size, ...sx }} />
    )
}
